import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from './Nav'
import { useLoadScript } from '@react-google-maps/api';
import Autocomplete from 'react-google-autocomplete';
import MenuHeader from './MenuHeader';
import { useLocation } from 'react-router-dom';
import AddressService from '../services/address.service';
import useAuth from '../hooks/useAuth';
import useApi from '../hooks/useApi';
import { useNotifications } from '../context/NotificationProvider';
import Modal from "react-modal";
import ZoneService from '../services/zone.service';
import UnavailableZoneService from '../services/unavailable_zones.service';
import croix from "../assets/images/close-black.png";
import { endpoints } from '../utils/utils';
import DomainService from '../services/domain.service';
import { useTranslation } from 'react-i18next';
import { usePrompt } from '../hooks/usePrompt';
import HotelService from '../services/hotel.service';

// session/module-level caches to avoid repeated hotel lookups during SPA navigation
const hotelLookupCache = new Map();
// in-flight promises to dedupe concurrent requests for the same hotel id
const hotelFetchInFlight = new Map();
// Enable verbose matching debug to help diagnose missed hotel detections (dev only)
const MATCH_DEBUG = true;

const EDIT_STEP_PATHS = [
  '/choose-location',
  '/choose-service',
  '/choose-therapist',
  '/payment'
];

const customStyles = {
  content: {
    width: "33%",
    top: "50%",
    padding: "40px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const customStyles2 = {
  content: {
    width: "33%",
    top: "50%",
    padding: "0px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "0px",
    boxShadow: "none",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};


const getInitialState = () => {
  try {
    const state = JSON.parse(sessionStorage.getItem("state") ?? '{}');
    const duo = state.duo ?? false;

    // Normalize therapists
    let therapists = state.selectedTherapists ?? [];
    if (duo) {
      therapists = therapists.length === 2 ? therapists : [therapists[0], null];
    } else {
      therapists = [therapists[0]].filter(Boolean);
    }

    // Normalize services
    let services = state.selectedServices ?? [];
    if (duo) {
      services = services.length === 2 ? services : [services[0], null];
    } else {
      services = [services[0]].filter(Boolean);
    }

    return {
      address: state.address ?? {
        id: state.address?.id ?? null,
        street: '',
        city: '',
        zip_code: '',
        street_number: '',
        state: '',
        state_code: '',
        country: 'Switzerland',
        country_code: 'CH',
        lat: null,
        lng: null,
      },
      phone: state.phone ?? '',
      selectedServices: services,
      selectedTherapists: therapists,
      duo,
    };
  } catch (e) {
    return {
      address: {
        id: null,
        street: '',
        city: '',
        zip_code: '',
        street_number: '',
        state: '',
        state_code: '',
        country: 'Switzerland',
        country_code: 'CH',
        lat: null,
        lng: null,
      },
      phone: '',
      selectedServices: [],
      selectedTherapists: [],
      duo: false,
    };
  }
};



Modal.setAppElement("#root");

const libraries = ['places'];
const ChooseLocation = () => {

  const loc = useLocation();
  const navigate = useNavigate();
  const notify = useNotifications();
  const { t } = useTranslation('location');
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const [modalIsOpen3, setIsOpen3] = useState(false);
  const [modalIsOpenService, setIsOpenService] = useState(false);
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });
  const { auth } = useAuth();
  const api = useApi();
  const [hotelAddress, setHotelAddress] = useState();
  const [hotel, setHotel] = useState();
  const [checkingHotel, setCheckingHotel] = useState(false);
  const { address: initialAddress, phone: initialPhone, selectedServices, duo, selectedTherapists } = getInitialState();
  const [address, setAddress] = useState(initialAddress);
  const [phone, setPhone] = useState(initialPhone);
  const [user, setUser] = useState();
  const isEditBookingMode = sessionStorage.getItem("editBookingMode") === "true" || loc.state?.fromEditBooking;
  const [isEditing, setIsEditing] = useState(isEditBookingMode);
  const [guardEnabled, setGuardEnabled] = useState(true);

  const location = useLocation();
  const [showPostalField, setShowPostalField] = useState(false);


  usePrompt(
    isEditBookingMode && guardEnabled,
    "Êtes-vous sûr de vouloir quitter la modification ? Vos changements ne seront pas enregistrés.",
    next => EDIT_STEP_PATHS.some(p => next.pathname.startsWith(p)) || next.pathname.startsWith('/hotel-choose-service') || next.pathname.startsWith('/hotels')
  );


  useEffect(() => {
    const prev = JSON.parse(sessionStorage.getItem('state') ?? '{}');
    sessionStorage.setItem('state', JSON.stringify({ ...prev, address, phone }));
  }, [address, phone]);

  useEffect(() => {
    if (isEditBookingMode) setIsEditing(true);
  }, [isEditBookingMode]);

  const [email, setEmail] = useState("");
  const handleSubmitEmail = async (e) => {
    e.preventDefault();

    // const updatedState = { ...JSON.parse(sessionStorage.getItem('state') ?? '{}'), address, phone };
    // sessionStorage.setItem('state', JSON.stringify(updatedState));

    // Prepare the data for submission
    const payload = {
      email: email,
      zip_code: address.zip_code,
      user_id: auth?.user?.id || null,
      zone_id: null
      // domain_id: auth?.user?.id || null,
      // is_zone: true,
      // is_service: false,
    };
    try {
      const response = await UnavailableZoneService.store(payload, api);

      if (response.success) {
        notify.success('Votre zone a été ajoutée avec succès');
      }
    } catch (error) {
      console.error('Error submitting email:', error);
    }
  };

  const closeModal = () => setIsOpen(false);
  const closeModal2 = () => setIsOpen2(false);
  const closeModal3 = () => setIsOpen3(false);
  const closeModalservice = () => setIsOpenService(false);

  const openModal = () => setIsOpen(true);
  const openModal2 = () => {

    setIsOpen2(true)
  };
  const openModal3 = () => {

    setIsOpen3(true)
  };
  const openModalservice = () => {

    setIsOpenService(true)
  };
  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleGoBack = () => {
    setIsEditing(false);
  };


  const onConfirm = () => {

    setGuardEnabled(false);
    setIsEditing(false);
    const newBooking = {
      address,
      phone,
      isDuo: duo,
      selectedServices,
      selectedTherapists,
      hotelId: hotel?.id,
      hotel
    };

    if (isEditBookingMode) {
      sessionStorage.setItem("newBooking", JSON.stringify(newBooking));
      sessionStorage.setItem("editBookingMode", "true");
      sessionStorage.setItem("selectedHotel", JSON.stringify(hotel));
      navigate("/hotels");
    } else {
      // Navigate to hotels with pre-selected hotel
      sessionStorage.setItem('selectedHotel', JSON.stringify(hotel));
      navigate('/hotels', { state: { hotel: hotel } });
    }
  };

  const handleEditClick = () => {
    setAddress({
      id: null,
      street: '',
      city: '',
      zip_code: '',
      street_number: '',
      state: '',
      state_code: '',
      country: 'Switzerland',
      country_code: 'CH',
      lat: null,
      lng: null,
    });
    setShowPostalField(false);
    setIsEditing(true);
  };

  const onContact = () => {
    navigate('/contact');
  };
  useEffect(() => {
    if (auth?.user?.phone) {
      setPhone(auth.user.phone ?? "");
    }
  }, [auth?.user]);
  useEffect(() => {
    const prev = getInitialState();
    sessionStorage.setItem('state', JSON.stringify({ ...prev, address, phone }));
  }, [address, phone]);

  function isZipCodeInRange(zipCode, range) {
    const ranges = range.split(',');
    const zip = parseInt(zipCode, 10);

    for (let element of ranges) {
      const trimmedElement = element.trim();

      if (trimmedElement.includes('-')) {
        const [start, end] = trimmedElement.split('-').map(Number);
        if (zip >= start && zip <= end) {
          return true;
        }
      } else {
        const singleZip = parseInt(trimmedElement, 10);
        if (zip === singleZip) {
          return true;
        }
      }
    }

    return false;
  }
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
      try {
        const response = await api.get(endpoints.getProfil);
        isMounted && setUser(response.data);
        if (response.data?.user?.primary_address) {
          setAddress({
            street: response.data.user?.primary_address.street || "",
            street_number: response.data.user?.primary_address.street_number || "",
            city: response.data.user?.primary_address.city || "",
            zip_code: response.data.user?.primary_address.zip_code || "",
            state: response.data.user?.primary_address.state || "",
            state_code: response.data.user?.primary_address.state_code || "",
            country: response.data.user?.primary_address.country || "",
            country_code: response.data.user?.primary_address.country_code || "",
            lat: response.data.user?.primary_address.latitude || null,
            lng: response.data.user?.primary_address.longitude || null,
          });
        }

      } catch (err) {
        // console.error(err);
        // navigate('/login', { state: { from: location }, replace: true });
      }
    }
    if (address?.id === null) {
      getUsers();

    }
    return () => {
      isMounted = false;
      controller.abort();
    }
  }, [])

  const checkZipCodeInRange = async (zip_code) => {
    try {
      const zoneResponse = await ZoneService.index(null, api, auth?.accessToken ? false : true);
      if (zoneResponse) {
        const zipNumeric = parseInt(zip_code, 10);
        let isInRange = false;


        for (const zone of zoneResponse) {

          if (isZipCodeInRange(zipNumeric, zone.zip_code)) {
            isInRange = true;
            break;
          }
        }

        return isInRange;
      } else {
        console.error("Erreur lors de la récupération des zones.");
      }
    } catch (error) {
      console.error("Erreur lors de l'appel de ZoneService.index :", error);
    }
  };


  const checkAdress = async (addrOverride = null) => {
    const addrToUse = addrOverride || address;

    if (checkingHotel) return false; // guard concurrent checks
    setCheckingHotel(true);

    const cleanup = (result = false) => {
      setCheckingHotel(false);
      return result;
    };

    try {
      if (addrToUse?.place_id) {
        const hotel = await lookupHotelByPlaceId(addrToUse.place_id);
        if (hotel !== null) {
          if (hotel) {
            setHotel(hotel);
            setHotelAddress(hotel.address ?? (hotel.address_id ? { id: hotel.address_id } : null));
            return cleanup(true);
          }
          return cleanup(false);
        }
      }

      if (!addrToUse.street && !addrToUse.zip_code && !addrToUse.city) {
        return cleanup(false);
      }

      const matchingAddress = await findHotelByAddress(addrToUse);
      if (!matchingAddress) {
        return cleanup(false);
      }

      setHotelAddress(matchingAddress);

      const hotel = await extractHotelFromAddress(matchingAddress);
      if (hotel) {
        setHotel(hotel);
        return cleanup(true);
      }

      return cleanup(false);
    } catch (error) {
      return cleanup(false);
    }
  };

  const lookupHotelByPlaceId = async (placeId) => {
    const placeKey = `place_${placeId}`;

    if (hotelLookupCache.has(placeKey)) {
      const cached = hotelLookupCache.get(placeKey);
      return cached;
    }

    if (hotelFetchInFlight.has(placeKey)) {
      return await hotelFetchInFlight.get(placeKey);
    }

    const fetchPromise = (async () => {
      try {
        const hotelsByPlace = await HotelService.index({
          google_place_id: placeId,
          with: 'address,addresses'
        }, api, auth?.accessToken ? false : true);

        const hotel = Array.isArray(hotelsByPlace) && hotelsByPlace.length > 0 ? hotelsByPlace[0] : null;

        return hotel;
      } catch (e) {
        console.error('Error looking up hotel by place_id:', e);
        return null;
      }
    })();

    hotelFetchInFlight.set(placeKey, fetchPromise);

    try {
      const result = await fetchPromise;
      hotelLookupCache.set(placeKey, result); // Cache result (including null)
      return result;
    } finally {
      hotelFetchInFlight.delete(placeKey);
    }
  };

  // Optimized address matching with early filtering
  const findHotelByAddress = async (targetAddr) => {
    const queryParams = {
      hotel_id: '!eq:null',
      with: 'hotel'
    };

    // Add specific filters if we have them to reduce API response size
    if (targetAddr.zip_code) {
      queryParams.zip_code = targetAddr.zip_code;
    } else if (targetAddr.city) {
      queryParams.city = targetAddr.city;
    }

    const addressResponse = await AddressService.index(queryParams, api, auth?.accessToken ? false : true);


    if (!addressResponse?.length) return null;

    return findMatchingAddress(targetAddr, addressResponse);
  };

  // Helper method to find matching address using optimized logic
  const findMatchingAddress = (targetAddr, addresses) => {
    if (!targetAddr || !addresses?.length) return null;

    // Pre-normalize target address components once
    const normalizeText = (str = '') => ('' + str).toLowerCase().trim().replace(/[^\w\s]/g, '').replace(/\s+/g, ' ');
    const normalizeNumber = (n = '') => ('' + n).toLowerCase().replace(/[^0-9a-z]/g, '').trim();

    const target = {
      street: normalizeText(targetAddr.street || ''),
      number: normalizeNumber(targetAddr.street_number || ''),
      city: normalizeText(targetAddr.city || ''),
      zip: (targetAddr.zip_code || '').toString().trim(),
      lat: targetAddr.lat,
      lng: targetAddr.lng
    };

    // Early exit if no meaningful target data
    if (!target.street && !target.city && !target.zip) return null;

    // Pre-filter addresses by zip or city if available (most selective filters first)
    let candidates = addresses;
    if (target.zip) {
      candidates = addresses.filter(addr => (addr.zip_code || '').toString().trim() === target.zip);
    } else if (target.city) {
      candidates = addresses.filter(addr =>
        normalizeText(addr.city || '') === target.city
      );
    }

    // If no candidates after filtering, return null early
    if (!candidates.length) return null;

    // Find best match
    for (let addr of candidates) {
      const match = evaluateAddressMatch(addr, target);
      if (match) {
        return addr;
      }
    }

    return null;
  };

  // Optimized address matching evaluation
  const evaluateAddressMatch = (addr, target) => {
    // Parse address street and number (handle embedded numbers)
    let addrStreet = addr.street || '';
    let addrNumber = addr.street_number || '';

    if (!addrNumber && addrStreet) {
      const leadingMatch = addrStreet.match(/^\s*(\d+\w?)\s+(.+)$/);
      const trailingMatch = addrStreet.match(/^(.+?)\s+(\d+\w?)\s*$/);

      if (leadingMatch) {
        addrNumber = leadingMatch[1];
        addrStreet = leadingMatch[2];
      } else if (trailingMatch) {
        addrNumber = trailingMatch[2];
        addrStreet = trailingMatch[1];
      }
    }

    const normalizeText = (str = '') => ('' + str).toLowerCase().trim().replace(/[^\w\s]/g, '').replace(/\s+/g, ' ');
    const normalizeNumber = (n = '') => ('' + n).toLowerCase().replace(/[^0-9a-z]/g, '').trim();

    const candidate = {
      street: normalizeText(addrStreet),
      number: normalizeNumber(addrNumber),
      city: normalizeText(addr.city || ''),
      zip: (addr.zip_code || '').toString().trim()
    };

    const matches = {
      street: candidate.street && target.street &&
        (candidate.street.includes(target.street) || target.street.includes(candidate.street)),
      number: candidate.number && target.number &&
        (candidate.number === target.number ||
          candidate.number.startsWith(target.number) ||
          target.number.startsWith(candidate.number)),
      city: candidate.city && target.city && candidate.city === target.city,
      zip: candidate.zip && target.zip && candidate.zip === target.zip
    };

    // Scoring system: require street match + at least one other match
    if (!matches.street) {
      // Geographic fallback if no street match but coordinates available
      if (target.lat != null && target.lng != null &&
        addr.latitude != null && addr.longitude != null) {
        const distance = calculateDistance(target.lat, target.lng, addr.latitude, addr.longitude);
        if (distance <= 100) {
          return {
            score: 50,
            reasons: [`geographic_match_${Math.round(distance)}m`]
          };
        }
      }
      return null;
    }

    // Calculate match score
    let score = 60; // Base score for street match
    const reasons = ['street_match'];

    if (matches.number) { score += 30; reasons.push('number_match'); }
    if (matches.zip) { score += 25; reasons.push('zip_match'); }
    if (matches.city) { score += 20; reasons.push('city_match'); }

    // Require minimum score threshold - be more strict
    const threshold = matches.number ? 90 : (matches.zip || matches.city) ? 85 : 60;

    return score >= threshold ? { score, reasons } : null;
  };

  // Helper method to calculate distance between two coordinates
  const calculateDistance = (lat1, lng1, lat2, lng2) => {
    const toRad = (v) => v * Math.PI / 180;
    const R = 6371000; // Earth's radius in meters
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) + 
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
              Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  };

  // Helper method to extract hotel from address object
  const extractHotelFromAddress = async (address) => {
    if (!address) return null;

    // Handle different relationship formats
    if (address.hotel) {
      if (Array.isArray(address.hotel) && address.hotel.length > 0) {
        return address.hotel[0]; // hasMany relationship
      } else if (!Array.isArray(address.hotel) && typeof address.hotel === 'object') {
        return address.hotel; // belongsTo relationship
      }
    }

    // Fallback: fetch hotel by ID
    if (address.hotel_id != null) {
      const cacheKey = `hotel_${address.hotel_id}`;

      if (hotelLookupCache.has(cacheKey)) {
        return hotelLookupCache.get(cacheKey);
      }

      try {
        const hotel = await HotelService.get(address.hotel_id, null, api, auth?.accessToken ? false : true);
        if (hotel) hotelLookupCache.set(cacheKey, hotel);
        return hotel;
      } catch (e) {
        console.error('Error fetching hotel:', e);
        return null;
      }
    }

    return null;
  };
  const fetchAllDomains = async (authAdrs = null) => {
    try {
      const response = await DomainService.index(
        { with: 'media,zones', sort: 'ordering' },
        api,
        !auth?.accessToken
      );

      const userZip = parseInt(authAdrs?.zip_code ?? address.zip_code, 10);

      const filteredDomains = response.filter(domain =>
        domain.is_active && domain.zones?.some(({ zip_code }) =>
          isZipCodeInRange(userZip, zip_code)
        )
      );
      return filteredDomains;

    } catch (error) {
      console.error("Error fetching domains:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (address.lat === null && address.lng === null) {
      notify.warn(t('invalid_adress_message'));
      openModal3()
      return;
    }

    if (!address.zip_code) {
      notify.warn(t('please_enter_postal_code'));
      setShowPostalField(true);
      return;
    }
    const filteredDomains = await fetchAllDomains();


    const updatedState = { ...JSON.parse(sessionStorage.getItem('state') ?? '{}'), address, phone };
    sessionStorage.setItem('state', JSON.stringify({
      ...updatedState,
      selectedServices,
      selectedTherapists,
      duo
    }));

    // Check if the address matches a known hotel first (priority)
    const hasHotelId = await checkAdress();
    if (hasHotelId) {
      notify.warn(t('hotel_address_short'));
      openModal();
      return;
    }

    const isOneZone = await checkZipCodeInRange(address.zip_code);
    if (!isOneZone) {
      notify.warn(t('zone_not_served'));
      openModal2();
      return;
    }

    if (filteredDomains.length == 0) {
      notify.warn(t('service_not_served'));
      openModalservice();
      return;
    }
    if (!address.zip_code) {
      notify.warn(t('invalid_poste_code'));
    }

    navigate('/choose-service', { state: { address, phone } });
  };

  const handleSubmitAuth = async (event) => {
    event.preventDefault();
    if (address.lat === null && address.lng === null) {
      notify.warn(t('invalid_adress'));
      openModal3()
      return;
    }
    const authAddress = user.user.primary_address;
    const filteredDomains = await fetchAllDomains(authAddress);
    const formattedAddress = {
      ...authAddress,
      lng: authAddress.longitude,
      lat: authAddress.latitude,
    };
    delete formattedAddress.longitude;
    delete formattedAddress.latitude;

    setAddress(formattedAddress);

    // reset state before proceeding
    sessionStorage.setItem('state', JSON.stringify({ address: formattedAddress, phone: user?.user?.phone }));

    const isOneZone = await checkZipCodeInRange(formattedAddress.zip_code);
    if (!isOneZone) {
      notify.warn(t('zone_not_served'));
      openModal2()
      return;
    }

    if (filteredDomains.length == 0) {
      notify.warn(t('service_not_served'));
      openModalservice()
      return;
    }

    const hasHotelId = await checkAdress(formattedAddress);
    if (hasHotelId) {
      notify.warn(t('hotel_address_short'));
      openModal()
      return;
    }
    if (!formattedAddress.zip_code) {
      notify.warn(t('please_enter_postal_code'));
    }


    navigate('/choose-service', { state: { address: formattedAddress, phone: user?.user?.phone } });
  };

  const handlePlaceSelect = (place) => {
    const addressComponents = place.address_components;
    const newAddress = {
      street: '',
      city: '',
      zip_code: '',
      street_number: '',
      state: '',
      state_code: '',
      country: 'Switzerland',
      country_code: 'CH',
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
      place_id: place.place_id,
    };
    for (const component of addressComponents) {
      const componentType = component.types[0];
      switch (componentType) {
        case 'street_number':
          newAddress.street_number = component.long_name;
          break;
        case 'route':
          newAddress.street = component.long_name;
          break;
        case 'locality':
          newAddress.city = component.long_name;
          break;
        case 'postal_code':
          newAddress.zip_code = component.long_name;
          break;
        case 'administrative_area_level_1':
          newAddress.state = component.long_name;
          newAddress.state_code = component.short_name;
          break;
      }
    }

    // Fallback: if no street_number was found but we have a formatted address,
    // try to extract it from the full address string
    if (!newAddress.street_number && place.formatted_address) {
      const fullAddress = place.formatted_address;
      // Try to extract leading number: "32, Rue du Petit-Chêne, Lausanne..."
      const leadingMatch = fullAddress.match(/^\s*(\d+\w?)\s*[,\-]?\s*(.+)$/);
      if (leadingMatch) {
        newAddress.street_number = leadingMatch[1];
      }
    }

    // Additional fallback: if we have a street name but no number, check if the street contains the number
    if (!newAddress.street_number && newAddress.street) {
      const streetWithNumber = newAddress.street.match(/^\s*(\d+\w?)\s+(.+)$/);
      if (streetWithNumber) {
        newAddress.street_number = streetWithNumber[1];
        newAddress.street = streetWithNumber[2];
      }
    }

    setAddress(newAddress);

    const prevState = JSON.parse(sessionStorage.getItem('state') ?? '{}');
    sessionStorage.setItem('state', JSON.stringify({ ...prevState, address: newAddress }));
  };

  if (loadError) return <div>{t('error_messages.loading_maps')}</div>;
  if (!isLoaded) return <div>{t('error_messages.loading')}</div>;

  return (
    <>
      <MenuHeader />
      <Nav page="adresse" />

      <div className="container ">
        <h2>{t('where_care')}</h2>

        {!isEditing && user?.user?.primary_address && !location.state?.fromEditBooking && sessionStorage.getItem("editBookingMode") !== "true" ? (
          <form onSubmit={handleSubmitAuth}>
            <div className="container container-profile">
              <div className="adress">
                <h3>{t('address')}</h3>
                <div className="rue">
                  {loc?.state?.fromEditBooking
                    ? (
                      <>
                        {address?.street} {address?.street_number}
                        <br />
                        {address?.zip_code} {address?.city || address?.state}
                      </>
                    ) : (
                      <>
                        {user?.user?.primary_address?.street} {user?.user?.primary_address?.street_number}
                        <br />
                        {user?.user?.primary_address?.zip_code} {user?.user?.primary_address?.city}
                      </>
                    )}
                  <br />
                  {/* {phone} */}
                </div>
                <a href="#" className="edit" onClick={handleEditClick}>{t('edit')}</a>
              </div>
            </div>
            <br />
            <div className='btn-bottom'>
              <button type="submit" className="btn btn-primary">
                {t('next')}
              </button>
            </div>
          </form>

        ) : (
          <>
            <div className="container-location">
              <div className="form-group">
                <label htmlFor="street">{t('enter_address')}</label>
                {isLoaded ? (
                  <Autocomplete
                    defaultValue={`${address.street} ${address.street_number}`}
                    apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                    onPlaceSelected={handlePlaceSelect}
                    placeholder={t('placeholder_address')}
                    options={{
                      types: ['address'],
                      componentRestrictions: { country: 'CH' },
                    }}
                    style={{
                      width: '100%',
                      padding: '0 15px',
                      height: '60px',
                      border: '0',
                      borderRadius: '20px',
                      boxShadow: '0px 8px 50px 0px rgba(0, 0, 0, 0.06)',
                    }}
                  />
                ) : (
                  <input
                    type="text"
                    placeholder={t('placeholder_address')}
                    defaultValue={address.street}
                    style={{
                      width: '100%',
                      padding: '0 15px',
                      height: '60px',
                      border: '0',
                      borderRadius: '20px',
                      boxShadow: '0px 8px 50px 0px rgba(0, 0, 0, 0.06)',
                    }}
                    disabled
                  />
                )}
              </div>
              {/* <div className="form-group">
                <label htmlFor="phone">Saisissez votre téléphone</label>
                <input
                  type="tel"
                  id="phone"
                  className="form-control"
                  placeholder="Ex: +41 00 000 00 00"
                  defaultValue={user?.user?.phone}
                  onChange={handlePhoneChange}
                  maxLength="16"
                  required
                />
              </div> */}
            </div>
            {/* <button className="btn btn-secondary" onClick={handleGoBack}>
              Retour
            </button> */}
          </>
        )}
        {((isEditing || !user?.user || !user?.user?.primary_address) && address.lat && address.lng) && (
          <form onSubmit={handleSubmit}>
            <div className="container-location">
              <div className="form-group">
                {/* <label htmlFor="street">Rue</label> */}
                <input
                  type="hidden"
                  id="street"
                  className="form-control"
                  value={address.street}
                  onChange={(e) => setAddress({ ...address, street: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                {/* <label htmlFor="street">Rue</label> */}
                <input
                  type="hidden"
                  id="street"
                  className="form-control"
                  value={address.street_number}
                  onChange={(e) => setAddress({ ...address, street_number: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                {/* <label htmlFor="state">Canton</label> */}
                <input
                  type="hidden"
                  id="state"
                  className="form-control"
                  value={address.state}
                  onChange={(e) => setAddress({ ...address, state: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                {showPostalField && (
                  <>
                    <label htmlFor="postalCode">{t('postal_code')}</label>
                    <input
                      type="text"
                      id="postalCode"
                      className="form-control"
                      value={address.zip_code}
                      onChange={(e) =>
                        setAddress({ ...address, zip_code: e.target.value })
                      }
                    />
                  </>
                )}
              </div>
              <div className="form-group">
                {/* <label htmlFor="city">Ville</label> */}
                <input
                  type="hidden"
                  id="city"
                  className="form-control"
                  value={address.city}
                  onChange={(e) => setAddress({ ...address, city: e.target.value })}
                  required
                />
              </div>
            </div>

            <div className='btn-bottom'>
              <button type="submit" className="btn btn-primary">
                {t('next')}
              </button>
            </div>
          </form>
        )}

      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles2}
        contentLabel="Example Modal"
        id="custom-popup-content"
      >
        <div className="contentModal">
          <div className="modal">
            {hotel && (!hotel.is_only_internal ? (
              <>
                <p className="modal-text">
                  {t('hotel_address_message')}
                </p>
                <h2 className="modal-hotel-name">
                  {hotel?.name}
                  <span className="modal-rating">
                    {hotel?.extra?.google_rating?.rating ? (
                      `⭐ ${Number(hotel.extra.google_rating.rating).toFixed(1)}/5 ${hotel.extra.google_rating.user_ratings_total ? `(${hotel.extra.google_rating.user_ratings_total})` : ''}`
                    ) : hotel?.extra?.rating ? (
                      `⭐ ${Number(hotel.extra.rating).toFixed(1)}/5`
                    ) : (
                      ''
                    )}
                  </span>
                </h2>
                <p className="modal-distance">
                  {t('hotel_distance', { distance: hotel?.distance_from_center })}
                </p>
                <p className="modal-address">
                  {t('address_label')}
                  <span className='address-detail'>
                    {hotelAddress?.street_number} {hotelAddress?.street}, {hotelAddress?.zip_code} {hotelAddress?.city}, {hotelAddress?.country}
                  </span>
                </p>
                <div className="modal-button-container">
                  <button className="modal-ok-button" onClick={onConfirm}>
                    {t('ok')}
                  </button>
                  <button className="modal-cancel-button" onClick={closeModal}>
                    {t('cancel')}
                  </button>

                </div>
              </>
            ) : (
              <>
                <p className="modal-text2" style={{ whiteSpace: 'pre-line' }}>
                  {t('hotel_address_internal')}{' '}
                  {hotel?.phone && (
                    <a href={`tel:${hotel.phone}`} style={{ color: '#faef9b' }}>
                      {hotel.phone}
                    </a>
                  )}
                </p>
                <button className="modal-ok-button" onClick={closeModal}>
                  {t('close')}
                </button>
              </>

            ))}
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={modalIsOpen2}
        onRequestClose={closeModal2}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="zone-not-served-container">
          <div className="popup-box">
            <button onClick={closeModal2} className="close-btn"><img src={croix} alt="Fermer" /></button>
            <h2>{t('zone_not_served')}</h2>
            <p style={{ marginBottom: "20px", whiteSpace: "pre-line" }}>
              {t('stay_informed')}
            </p>
            <form onSubmit={handleSubmitEmail}>
              <label htmlFor="email">{t('email_address')} *</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="send-btn">{t('send')}</button>
            </form>
            <button onClick={onContact} className="support-btn">{t('contact_support')}</button>
          </div>
        </div>
      </Modal >

      <Modal
        isOpen={modalIsOpen3}
        onRequestClose={closeModal3}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="zone-not-served-container">
          <div className="popup-box">
            <button onClick={closeModal3} className="close-btn"><img src={croix} alt="Fermer" /></button>
            <h2>{t('invalid_adress')}</h2>
            <p style={{ marginBottom: "20px" }}>
              {t('invalid_adress_message')}
            </p>

          </div>
        </div>
      </Modal >
      <Modal
        isOpen={modalIsOpenService}
        onRequestClose={closeModalservice}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="zone-not-served-container">
          <div className="popup-box">
            <button onClick={closeModalservice} className="close-btn"><img src={croix} alt="Fermer" /></button>
            <h2>{t('service_not_served')}</h2>
            <p style={{ whiteSpace: "pre-line" }}>
              {t('stay_informed')}</p>
            <form onSubmit={handleSubmitEmail}>
              <label htmlFor="email">{t('email_address')}</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="send-btn">{t('send')}</button>
            </form>
            <button onClick={onContact} className="support-btn">{t('contact_support')}</button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ChooseLocation;
